/**
 * TENANT-AIKEY-REQUIRED-01 (O-67, O-69/OQ-13), amended by CRED-COST-01
 * (ADR-0028, O-86): every clinic runs on its own model key, which CliniSharp
 * issues; the shared platform key is no fallback. Laravel refuses AI work for a
 * clinic without one with `error: "ai_key_missing"` (403, ADR-0006 fields
 * alongside); the web shows one sentence for it on every AI surface. The
 * sentence is ADR-0028 "Copy": the clinic never brings or handles a key.
 */
export const AI_KEY_MISSING_CODE = "ai_key_missing";

export const AI_KEY_MISSING_NOTICE =
  "A IA desta clínica ainda está em preparação pela CliniSharp. Enquanto isso, a equipe atende as conversas. Fale com o suporte se precisar de previsão.";

/** Where an admin reads the clinic's AI settings (`CopilotSettingsTab`). */
export const AI_KEY_SETTINGS_PATH = "/settings/automations";

export const AI_KEY_SETTINGS_LINK_LABEL = "Ver status em Configurações da IA";

/** True for the api refusal body, parsed or as the JSON text a transport error carries. */
export function isAiKeyMissing(body: unknown): boolean {
  let value = body;
  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch {
      return false;
    }
  }
  if (!value || typeof value !== "object") return false;
  const envelope = value as { error?: unknown; error_type?: unknown };
  return envelope.error === AI_KEY_MISSING_CODE || envelope.error_type === AI_KEY_MISSING_CODE;
}
